<template>
  <section class="n-section-primary tw-overflow-hidden">
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_top"
      :company-key="company.company_key"
    />
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="right_bottom"
      :company-key="company.company_key"
    />
    <div class="tw-absolute tw-inset-0" :style="`background-color: var(--c-${vars.backgroundColor})`"></div>
    <div class="container tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <div class="tw-mb-8 tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3">
        <h6 :style="`color: var(--c-${vars.textColor})`">{{ vars.altTitleText }}</h6>
        <h2 :style="`color: var(--c-${vars.textColor})`">{{ vars.titleText }}</h2>
      </div>
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="mb-3 tw-max-w-2xl"
          :style="`${vars.textColor ? `color: var(--c-${vars.textColor}) !important` : ''}`"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :target="button.link.startsWith('http') ? '_blank' : '_self'"
          :class="`n-${button.type} tw-w-full md:tw-w-auto`"
          :external="true"
          >{{ button.label }}</nuxt-link
        >
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'TakeAction',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {};
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
